import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery, getApiBaseUrl } from 'modules/api/utils';

interface MessengerTokenResponse {
  token: string;
}

export const intercomApi = createApi({
  reducerPath: 'intercomApi',
  baseQuery: axiosBaseQuery({ baseURL: getApiBaseUrl('v1') }),
  endpoints: (builder) => ({
    getMessengerToken: builder.query<MessengerTokenResponse, void>({
      query: () => ({
        url: '/intercom/messenger-token',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetMessengerTokenQuery } = intercomApi;
